<template>
  <div class="block">
    <div class="block__overlay" />
    <div v-for="(item, index) in destinations" :id="`image-${item.id}`" ref="backgroundImages" :key="index" class="block__background lazyload" :class="{ 'display-image' : index == 0}" :style="{ backgroundImage : `url('${item.image}')` }" />

    <h3 class="block__title uppercase text-center">
      {{ title }}
    </h3>
    <div>
      <ul class="block__links">
        <li v-for="item in destinations.slice(0, 3)" :key="item.name" :title="item.name" class="block__links--item uppercase text-center" :style="!isMobile ? { 'width': `${item.name.length * 40}px` } : {}" @mouseover="changeBackground(item)">
          <app-link :id="item.linkId" :type="item.linkType">
            {{ item.name }}
          </app-link>
        </li>
      </ul>
      <ul class="block__links">
        <li v-for="item in destinations.slice(3, 6)" :key="item.name" :title="item.name" class="block__links--item uppercase text-center" :style="!isMobile ? { 'width': `${item.name.length * 40}px` } : {}" @mouseover="changeBackground(item)">
          <app-link :id="item.linkId" :type="item.linkType">
            {{ item.name }}
          </app-link>
        </li>
      </ul>
    </div>
    <div class="block__button">
      <app-link id="437" type="collection" class="btn-secondary-light-sm">
        {{ buttonText }}
      </app-link>
    </div>
  </div>
</template>

<script>
import responsive from '../mixins/responsive';

export default {
  mixins: [responsive],
  props: {
    title: { type: String, default: 'Trending destinations' },
    buttonText: { type: String, default: 'Search all villas' },
    destinations: { type: Array },
  },
  methods: {
    changeBackground(item) {
      const images = this.$refs.backgroundImages;
      images.forEach((image) => {
        image.classList.remove('display-image');
      });
      const x = document.getElementById(`image-${item.id}`);
      x.classList.add('display-image');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";

.block {
  height: 680px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  &__overlay {
    background-color: rgba(5, 8, 23, 0.3);
    height: 680px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  &__background {
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.2s ease-in;
    height: 680px;
    width: 100%;
    background-size: cover;
    background-position: center center;
    opacity: 0;
    z-index: -2;
  }
  &__title {
    margin-top: 3rem;
    font-size: 24px;
    letter-spacing: 0.07em;
    color: $stoneWhite;
    @media (max-width: 768px) {
    font-size: 16px;
    }
  }
  &__links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    @media (max-width: 768px) {
    display: block;
    text-align: center;
    }
    &--item {
    margin: 0 40px;
      & a {
        color: $lunarioAcid;
        font-size: 64px;
        font-family: $font-family-editorial;
        transition: ease;
        &:hover {
          font-style: italic;
        }
        @media (max-width: 768px) {
        font-size: 40px
        }
      }
    }
  }
  &__button {
    margin-bottom: 3rem;
  }
}

.display-image {
  opacity: 1;
}

</style>
